"use client";

import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

type CopyButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  ["data-href"]?: string;
};

const MarkdownCopyButton: React.FC<CopyButtonProps> = (props) => {
  const href = props["data-href"];
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    if (href) {
      navigator.clipboard
        .writeText(href)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // vuelve al ícono original tras 2 segundos
        })
        .catch(console.error);
    }
  };

  // eliminamos data-href del DOM final
  const { ["data-href"]: _removed, ...rest } = props;

  return (
    <button {...rest} onClick={handleClick}>
      {copied ? (
        <Check size={24} />
      ) : (
        <Copy size={24} />
      )}
    </button>
  );
};

export default MarkdownCopyButton;
